export default __webpack_public_path__ + "static/media/Haydn in the air.ea6a51ea.jpg";